// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_auto_creation_rule_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { WorkflowAutoCreationRuleService } from "./workflow_auto_creation_rule_service_pb";

/**
 * ListWorkflowAutoCreationRules returns the active rules of the
 * organization, ordered by created_at then id. Rules whose template is
 * deleted or cannot be resolved are not returned.
 *
 * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.ListWorkflowAutoCreationRules
 */
export const listWorkflowAutoCreationRules = WorkflowAutoCreationRuleService.method.listWorkflowAutoCreationRules;

/**
 * CreateWorkflowAutoCreationRules creates one rule per requested area,
 * skipping areas that already have a scheduled rule for the same template.
 * Returns ALREADY_EXISTS when every requested area is skipped, and
 * FAILED_PRECONDITION when the template does not exist in the organization
 * or cannot have a scheduled rule.
 *
 * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.CreateWorkflowAutoCreationRules
 */
export const createWorkflowAutoCreationRules = WorkflowAutoCreationRuleService.method.createWorkflowAutoCreationRules;

/**
 * UpdateWorkflowAutoCreationRule replaces a rule. When the template or the
 * area changes, the rule is recreated under a new id (the old rule is
 * logically deleted) and the response carries the new id. Returns
 * ALREADY_EXISTS on a template × area clash, FAILED_PRECONDITION for an
 * ineligible template, NOT_FOUND for a missing rule and ABORTED when
 * expected_updated_at does not match.
 *
 * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.UpdateWorkflowAutoCreationRule
 */
export const updateWorkflowAutoCreationRule = WorkflowAutoCreationRuleService.method.updateWorkflowAutoCreationRule;

/**
 * DeleteWorkflowAutoCreationRule logically deletes a rule. Returns NOT_FOUND
 * for a missing rule and ABORTED when expected_updated_at does not match.
 *
 * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.DeleteWorkflowAutoCreationRule
 */
export const deleteWorkflowAutoCreationRule = WorkflowAutoCreationRuleService.method.deleteWorkflowAutoCreationRule;
